import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "banner-section" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "center-aligned-div mt-2" }
const _hoisted_4 = {
  class: "mb-2",
  style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          textAlign: 'left',
        }
}
const _hoisted_5 = { class: "ml-2 pub-title" }
const _hoisted_6 = { class: "center-aligned-div mt-2" }

import { collection, doc, DocumentSnapshot, getDocs, getDoc, limit, orderBy, query, deleteDoc } from 'firebase/firestore'
import { ref as storageRef, getDownloadURL, deleteObject } from 'firebase/storage'
import { ref, onMounted, watch } from 'vue'
import { useTheme } from 'vuetify'
import { firestore as db, storage, auth } from '@/main'
import { Publication } from '@/types/Publication'
import { Delta } from '@vueup/vue-quill'
import { onAuthStateChanged } from 'firebase/auth'
import { CommonBoardItem } from '@/types/CommonBoardItem'

import '@vueup/vue-quill/dist/vue-quill.bubble.css'
import router from '@/router'
import HomeBoardListItem from '@/components/home/HomeBoardListItem.vue'
import BoardItemModal from '@/components/board/BoardItemModal.vue'
import HomeContactItem from '@/components/home/HomeContactItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const theme = useTheme()

const isPlaying = ref(true)
const isSignedIn = ref(false)
const showWindow = ref(false)
const isLoading = ref(false)

const selectedItem = ref<CommonBoardItem | undefined>(undefined)

const newsQuery = query(collection(db, 'News'), orderBy('date', 'desc'), limit(5))
const publicationsQuery = query(collection(db, 'Publications'), orderBy('year', 'desc'), limit(5))
const galleryQuery = query(collection(db, 'Gallery'), orderBy('date', 'desc'), limit(5))
const contactRef = doc(db, 'Contact', 'Introduction')

const newsList = ref<CommonBoardItem[]>([])
const galleryList = ref<CommonBoardItem[]>([])
const publicationList = ref<Publication[]>([])
const phone = ref('')
const email = ref('')
const address = ref('')
const bannerURL = ref('')
const bannerType = ref<'Image' | 'Video'>('Video')

onMounted(() => {
  getDoc(doc(db, 'Banner', 'Contents'))
    .then((doc: DocumentSnapshot) => {
      if (doc.exists()) {
        const data = doc.data()
        bannerType.value = data.type

        getDownloadURL(storageRef(storage, `banner/${data.fileName}`))
          .then((url) => {
            bannerURL.value = url
          })
          .catch((e: Error) => {
            console.log(e.message)
          })
      }
    })
    .catch((e: Error) => {
      console.log(e.message)
    })

  getDocs(newsQuery)
    .then((docs) => {
      newsList.value = docs.docs.map((doc) => ({
        ...(doc.data() as CommonBoardItem),
        id: doc.id,
        contentsDelta: doc.data().contents === '' || doc.data().contents === undefined ? undefined : new Delta(JSON.parse(doc.data().contents || '{}')),
        showContents: false,
        category: 'News'
      }))
    })
    .catch((e: Error) => {
      console.log(e.message)
    })

  getDocs(publicationsQuery)
    .then((docs) => {
      docs.forEach((doc) => {
        publicationList.value.push({
          id: doc.id,
          contents: doc.data().contents,
          link: doc.data().link,
          type: doc.data().type,
          year: doc.data().year
        })
      })
    })
    .catch((e: Error) => {
      console.log(e.message)
    })

  getDocs(galleryQuery)
    .then((docs) => {
      galleryList.value = docs.docs.map((doc) => ({
        ...(doc.data() as CommonBoardItem),
        id: doc.id,
        contentsDelta: doc.data().contents === '' || doc.data().contents === undefined ? undefined : new Delta(JSON.parse(doc.data().contents || '{}')),
        showContents: false,
        category: 'Gallery'
      }))
    })
    .catch((e: Error) => {
      console.log(e.message)
    })

  getDoc(contactRef)
    .then((doc: DocumentSnapshot) => {
      if (doc.exists()) {
        const data = doc.data()
        phone.value = data.tel
        email.value = data.email
        address.value = data.address
      }
    })
    .catch((e: Error) => {
      console.log(e.message)
    })
})

function togglePlayPause () {
  const videoElement = document.getElementById('banner-video') as HTMLVideoElement
  if (videoElement) {
    videoElement.addEventListener('play', () => { isPlaying.value = true })
    videoElement.addEventListener('pause', () => { isPlaying.value = false })
  }

  if (!videoElement) return
  if (videoElement.paused) {
    videoElement.play()
  } else {
    videoElement.pause()
  }

  videoElement.removeEventListener('play', () => { isPlaying.value = true })
  videoElement.removeEventListener('pause', () => { isPlaying.value = false })
}

function onItemClick (item: CommonBoardItem) {
  selectedItem.value = item
  showWindow.value = true
}

function call () {
  document.location.href = `tel:${phone.value}`
}

function mailTo () {
  document.location.href = `mailto:${email.value}`
}

function openMap () {
  const query = encodeURIComponent(address.value)
  window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank')
}

function onCloseWindow () {
  selectedItem.value = undefined
  showWindow.value = false
}

function modifyItem (item: CommonBoardItem) {
  showWindow.value = false
  router.push({
    name: 'modifyPost',
    state: {
      post: {
        id: item.id,
        contents: item.contents,
        title: item.title,
        date: item.date,
        category: item.category
      }
    }
  })
}

function deleteItem (item: CommonBoardItem) {
  if (confirm(`Are you sure you want to delete post ${item.title}?\nThis action cannot be undone.`)) {
    showWindow.value = false
    isLoading.value = true
    deleteDoc(doc(db, item.category, item.id as string))
      .then(() => {
        if (item.image !== '' && item.image !== undefined && item.image !== null) {
          deleteObject(storageRef(storage, `${item.category.toLowerCase()}/img/${item.id}.${item.image.split('.').pop()?.split('?')[0]}`))
            .catch((e: Error) => {
              alert(`An error occurred while deleting image.\nPlease try again later.\n(${e.message})`)
            })
            .finally(() => {
              alert('Post deleted successfully.')
              newsList.value = newsList.value.filter(i => i.id !== item.id)
              isLoading.value = false
            })
        } else {
          alert('Post deleted successfully.')
          newsList.value = newsList.value.filter(i => i.id !== item.id)
          isLoading.value = false
        }
      })
      .catch((e: Error) => {
        alert(`An error occurred while deleting post.\nPlease try again later.\n(${e.message})`)
        isLoading.value = false
      })
  }
}

onAuthStateChanged(auth, () => {
  isSignedIn.value = auth.currentUser !== null
})

watch(showWindow, () => {
  if (!showWindow.value) {
    selectedItem.value = undefined
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (bannerURL.value !== '' && bannerType.value === 'Video')
          ? (_openBlock(), _createElementBlock("video", {
              key: 0,
              id: "banner-video",
              src: bannerURL.value,
              autoplay: "",
              loop: "",
              muted: "",
              controls: "false",
              playsinline: "true",
              controlslist: "nodownload nofullscreen noremoteplayback",
              "webkit-playsinline": ""
            }, null, 8, _hoisted_2))
          : (bannerURL.value !== '' && bannerType.value === 'Image')
            ? (_openBlock(), _createBlock(_component_v_img, {
                key: 1,
                src: bannerURL.value,
                id: "banner-video"
              }, null, 8, ["src"]))
            : (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 2,
                indeterminate: "",
                color: "primary",
                height: 1
              })),
        (bannerURL.value !== '' && bannerType.value === 'Video')
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 3,
              id: "play-pause-button",
              onClick: togglePlayPause,
              variant: "text",
              color: "white"
            }, {
              default: _withCtx(() => [
                (isPlaying.value)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: "fa-solid fa-pause-circle"
                    }))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      icon: "fa-solid fa-play-circle"
                    }))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_container, { class: "mt-2" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "text-h5 font-weight-bold center-aligned-div mb-2",
            style: _normalizeStyle({
          color: _unref(theme).current.value.colors.primary
        })
          }, "SBL TODAY", 4),
          _createVNode(HomeBoardListItem, {
            itemList: newsList.value,
            "onOn:itemClick": onItemClick
          }, null, 8, ["itemList"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              variant: "tonal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/news')))
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Show All", -1)
              ])),
              _: 1,
              __: [5]
            })
          ]),
          _createElementVNode("div", {
            class: "text-h5 font-weight-bold center-aligned-div mt-6 mb-2",
            style: _normalizeStyle({
          color: _unref(theme).current.value.colors.primary
        })
          }, "LATEST PUBLICATIONS ", 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(publicationList.value, (pub) => {
            return (_openBlock(), _createElementBlock("div", {
              key: pub.id
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(pub.contents), 1),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  href: pub.link
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-link",
                      class: "mr-1"
                    })
                  ]),
                  _: 2
                }, 1032, ["href"])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", {
            class: "center-aligned-div mt-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/publications')))
          }, [
            _createVNode(_component_v_btn, { variant: "tonal" }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Show All", -1)
              ])),
              _: 1,
              __: [6]
            })
          ]),
          _createElementVNode("div", {
            class: "text-h5 font-weight-bold center-aligned-div mt-6 mb-2",
            style: _normalizeStyle({
          color: _unref(theme).current.value.colors.primary
        })
          }, "SBL MOMENT", 4),
          _createVNode(HomeBoardListItem, {
            itemList: galleryList.value,
            "onOn:itemClick": onItemClick
          }, null, 8, ["itemList"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_btn, {
              variant: "tonal",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/gallery')))
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Show All", -1)
              ])),
              _: 1,
              __: [7]
            })
          ]),
          _createElementVNode("div", {
            class: "text-h5 font-weight-bold center-aligned-div mt-6 mb-2",
            style: _normalizeStyle({
          color: _unref(theme).current.value.colors.primary
        })
          }, "CONTACT ", 4),
          (phone.value !== '')
            ? (_openBlock(), _createBlock(HomeContactItem, {
                key: 0,
                icon: 'fa-solid fa-phone',
                label: phone.value,
                "onOn:click": call
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (email.value !== '')
            ? (_openBlock(), _createBlock(HomeContactItem, {
                key: 1,
                icon: 'fa-solid fa-envelope',
                label: email.value,
                "onOn:click": mailTo
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (address.value !== '')
            ? (_openBlock(), _createBlock(HomeContactItem, {
                key: 2,
                icon: 'fa-solid fa-location-pin',
                label: address.value,
                "onOn:click": openMap
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "center-aligned-div mt-2",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/contact')))
          }, [
            _createVNode(_component_v_btn, { variant: "tonal" }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Details", -1)
              ])),
              _: 1,
              __: [8]
            })
          ])
        ]),
        _: 1
      })
    ]),
    (showWindow.value && selectedItem.value !== undefined)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: showWindow.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showWindow).value = $event)),
          style: { backdropFilter: 'blur(5px)' }
        }, {
          default: _withCtx(() => [
            _createVNode(BoardItemModal, {
              "selected-item": selectedItem.value,
              "onOn:close": onCloseWindow,
              "onOn:update": modifyItem,
              "onOn:delete": deleteItem
            }, null, 8, ["selected-item"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})